// extracted by mini-css-extract-plugin
export default {"base":"Footer_base__WmHU5","links":"Footer_links__2VAlO","link":"Footer_link__sgKeT"};